import { render, staticRenderFns } from "./T-F-Grad-2024.vue?vue&type=template&id=4da19fc5&scoped=true"
import script from "./T-F-Grad-2024.vue?vue&type=script&lang=js"
export * from "./T-F-Grad-2024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da19fc5",
  null
  
)

export default component.exports